import React from "react";
import styled from 'styled-components'

const Col = styled.div`
  ${p => p.inlineCSS && p.inlineCSS};
`

export default  ({ extra = {}, children = null }) => {
  const { cols = 12,panel=true, style = {}, css, className = '' } = extra;

  return (
    <Col inlineCSS={css} className={`${className} col-md-${cols} d-flex ${ style.flexDirection ? `flex-${style.flexDirection}` : 'flex-column' } ${ style.alignItems && `align-items-${style.alignItems}` } ${ style.justifyContent && `justify-content-${style.justifyContent}` } `}>
      {children}
    </Col>
  );
};
 